import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const EmailNotificationService = {
  insertEmailNotificationDetails,
  updateEmailNotificationDetails,
  deleteEmailNotificationDetails,
  getNotificationDetailsByID,
  getSearchNotifications,
  getDLList,
  getEmailStatusList,
  getFromNameList,
  sendImmediateNotification,
};

async function insertEmailNotificationDetails(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_NOTIFICATION_DETAILS}`,
    formObj,
    authHeader()
  );
  return response;
}

async function updateEmailNotificationDetails(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.UPDATE_NOTIFICATION_DETAILS}`,
    formObj,
    authHeader()
  );
  return response;
}

async function getNotificationDetailsByID(notificationID) {
  const response = await APIHelper.get(
    APIURLConstants.GET_NOTIFICATION_DETAILS_BY_ID(notificationID),
    authHeader()
  );
  return response;
}

async function getDLList() {
  const response = await APIHelper.get(
    APIURLConstants.GET_DL_OPTION_LIST,
    authHeader()
  );
  return response;
}

async function getEmailStatusList() {
  const response = await APIHelper.get(
    APIURLConstants.GET_EMAIL_STATUS_LIST,
    authHeader()
  );
  return response;
}

async function getSearchNotifications(FromDate, ToDate, EmailStatus) {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_SEARCH_NOTIFICATION_LIST}?FromDate=${FromDate}&ToDate=${ToDate}&EmailStatus=${EmailStatus}`,
    authHeader()
  );
  return response;
}

async function deleteEmailNotificationDetails(NotificationId, UserBy) {
  const response = await APIHelper.post(
    APIURLConstants.DELETE_NOTIFICATION_DETAILS(NotificationId, UserBy),
    authHeader()
  );
  return response;
}

async function getFromNameList() {
  const response = await APIHelper.get(
    APIURLConstants.GET_EMAIL_FROM_LIST,
    authHeader()
  );
  return response;
}

async function sendImmediateNotification(
  dBatchRunDateTime,
  iNotificationId,
  userBy
) {
  const response = await APIHelper.get(
    `${APIURLConstants.SEND_DIRECT_NOTIFICATION}?BatchRunDateTime=${dBatchRunDateTime}&UserBy=${userBy}&NotificationId=${iNotificationId}`,
    authHeader()
  );
  return response;
}
